import { KeyValuePair } from "../../../util/collection/KeyValuePair";
import { EventHandler } from "../../../util/event/EventHandler";
import { ViewUtils } from "../../../util/view/ViewUtils";
import { ButtonGroup } from "../../control/ButtonGroup";
import { TitanButton } from "../../control/TitanButton";
import { TitanPanel } from "../../control/TitanPanel";
import { AbstractView } from "../AbstractView";
import { CommonLang } from "../lang/CommonLang";
/**
 * ResponsibleGamingPanel.ts
 */
export class ResponsibleGamingPanel extends AbstractView {
    constructor(properties) {
        super(properties);
        this.run();
    }
    createProperties(uiProperties) {
        super.createProperties(uiProperties);
        this.properties = uiProperties;
    }
    create() {
        super.create();
        this.createTitleField();
        this.panel = TitanPanel.createPanel(this, "panel", this.properties.panelProperties);
        this.createGroup();
    }
    onChange(action, scope) {
        this.changeHandler = new EventHandler(action, scope);
    }
    createTitleField() {
        this.titleField = ViewUtils.createField(this, this.properties.titleFieldProperties);
    }
    createGroup() {
        this.buttons = [];
        this.group = new ButtonGroup(true);
    }
    refresh(stake, option) {
        this.group.clearSelection();
        for (let button of this.buttons) {
            let data = button.getData();
            if (data.isEqual(option)) {
                this.group.setSelected(button, true);
            }
        }
        this.updateTitle(stake);
    }
    update(stake, options) {
        for (let option of options) {
            this.createResponsibleGamingButton(option);
        }
        this.updateTitle(stake);
        this.panel.arrange();
    }
    createResponsibleGamingButton(option) {
        let button = new TitanButton(this.properties.optionProperties);
        button.onClick(this.handleOptionSelected, this);
        button.setText(this.getOptionMessage(option));
        button.setData(option);
        this.panel.addToPanel(button, false);
        this.group.add(button);
        this.buttons.push(button);
        return button;
    }
    handleOptionSelected(button) {
        if (this.changeHandler) {
            this.changeHandler.call(button);
        }
    }
    updateTitle(stake) {
        let key = this.properties.langKey;
        let params = [];
        if (this.group.hasSelection()) {
            key += CommonLang.RESPONSIBLE_GAMING_ACTIVE_SUFFIX;
            let selection = this.group.getSelection();
            let option = selection.getData();
            let value = option.isExtraSpin() ? option.getValue().toString() : this.formatCurrency(stake * option.getValue());
            params.push(new KeyValuePair(CommonLang.PARAM_AMOUNT, value));
        }
        this.titleField.setText(this.langManager.getLang(key, params));
    }
    getOptionMessage(data) {
        let message = data.isExtraSpin() ? "" : "x";
        return message + data.getValue();
    }
    getHeight() {
        this.titleField.getHeight(); //initialise title text
        return super.getHeight();
    }
}
//# sourceMappingURL=ResponsibleGamingPanel.js.map